import {ResponseToken} from 'src/app/features/auth/shared/interfaces/auth-user-data.interface';
import {
  DetailFromFrontPageBenefit,
  FrontPageFromBenefit,
  FrontPageOption,
} from 'src/app/features/benefit/models/benefits.model';
import {
  CorporateEvent,
  Recurso,
} from 'src/app/features/gallery/models/event.moles';
import {AppNotification} from 'src/app/features/notification/models/notification.model';
import {PersonalData} from 'src/app/features/user/shared/options.model';
import {Post} from 'src/app/features/user/shared/post.model';

export const COMPANY_GROUP = 'g';
export const FORGOT_PASSWORD = 'FP';
export const PASSWORD_CHANGE = 'PC';
export const DECIMAL_BASE = 10;
export const SIGHU_PROFILE = 1;
export const SIGHU_CERTIFICATE = 2;
export const SIGHU_QUERIES = 3;
export const LENGTH_3 = 3;
export const LENGTH_4 = 4;
export const LENGTH_5 = 5;
export const LENGTH_6 = 6;
export const LENGTH_15 = 15;
export const LENGTH_30 = 30;
export const GENERIC_MESSAGE_ERROR =
  'Ocurrió un error inesperado, reportalo al Proceso de Gestión Humana.';
export const ERROR_UPDATING_MESSAGE =
  'No se logró marcar como vista la notificación, reportalo al Proceso de Gestión Humana.';
export const ERASER = 'ERASER';
export const MLS_200 = 200;
export const MLS_250 = 250;
export const MLS_300 = 300;
export const MLS_400 = 400;
export const MLS_450 = 450;
export const MLS_500 = 500;
export const MLS_2000 = 2000;
export const TRAVEL_RANGE = 50;
export const ERROR_CODE_401 = 401;
export const RESIDENCE_INFORMATION = 1;
export const FAMILY_INFORMATION = 2;
export const ACADEMIC_INFORMATION = 3;
export const SEVEN_HOURS = 7;

export const DEFAULT_IP = '100.100.100.10';
export const REQUIREMENTS_PSD = [
  {message: 'Mínimo 8 caracteres.', completed: false},
  {message: 'Al menos una letra minúscula.', completed: false},
  {message: 'Al menos una letra mayúscula.', completed: false},
  {
    message: 'Al menos un carácter especial (Ej. ! # $ % * ? -).',
    completed: false,
  },
  {message: 'Al menos dos números.', completed: false},
  {message: 'No puede ser igual a la contraseña actual.', completed: false},

  {
    message:
      'No debe contener caracteres repetidos consecutivamente (por ejemplo: aa, 11, $$).',
    completed: false,
  },
  {
    message:
      'No puedes incluir cinco números seguidos que coincidan con tu número de cédula.',
    completed: false,
  },
];
export const VIDEO_PREVIEW_TIME = 10;
export const EMPTY_RESPONSE_TOKEN: ResponseToken = {
  token: '',
  indResultado: 0,
  observacion: '',
  instruccion: '',
};
export const EMPTY_PERSONAL_DATA: PersonalData = {
  cedulaTrab: '',
  primerNombreTrab: '',
  segundoNombreTrab: '',
  primerApellidoTrab: '',
  segundoApellidoTrab: '',
  fotoTrab: '',
  celularTrab: '',
  emailPersonalTrab: '',
  nombreContactoTrab: '',
  telefonoContactoTrab: '',
  codCentroCostosTrab: '',
  nomCentroCostosTrab: '',
  nomSedeTrab: '',
  nomCompaniaTrab: '',
  emailCorporativoTrab: '',
  telefonoEmpresaTrab: '',
  codCompaniaTrab: '0',
};
export const EMPTY_POST: Post = {
  idPublicacion: 0,
  fechaPublicacion: new Date(),
  descripcion: '',
  recursos: [],
  comentarios: [],
  interacciones: 0,
  indicativoLike: false,
  indicativoComentario: false,
};
export const EMPTY_FRONTPAGEBENEFIT: DetailFromFrontPageBenefit = {
  idEncabezadoEnc: 0,
  idHomeEnc: 0,
  recursoGraficoEnc: '',
  contenidoEnc: '',
  indBotonEnc: false,
  rutaSolicitudEnc: '',
};
export const EMPTY_FRONTPAGEOPTION: FrontPageOption = {
  idDetalleDtl: 0,
  idEncabezadoDtl: 0,
  tituloDtl: '',
  contenidoDtl: '',
};

export const EMPTY_FRONT_PAGE_FROM_BENEFIT: FrontPageFromBenefit = {
  idHomeHm: 0,
  compañiaHm: 0,
  recursoGraficoHm: '',
  nombreHm: '',
};

export const EMPTY_APP_NOTIFICATION: AppNotification = {
  estadoNot: '0',
  idNotificacionNot: 0,
  tituloNot: '',
  idPublicacionNot: 0,
  tipoNotificacionNot: '',
  fechaProgramacionNot: new Date(),
  leidaNot: false,
};

export const EMPTY_RECURSO: Recurso = {
  idRecurso: 0,
  idGaleria: 0,
  tipoRecurso: '',
  linkRecurso: '',
};
export const EMPTY_CORPORATEEVENT: CorporateEvent = {
  idGaleria: 0,
  titulo: '',
  fecha: new Date(),
  recursos: [EMPTY_RECURSO, EMPTY_RECURSO, EMPTY_RECURSO],
};
